<h1 mat-dialog-title>
  <div id="id_filter_header" [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
    {{ 'LABEL_FILTER' | translate }}
  </div>
</h1>
 
<div mat-dialog-content fxLayout="column" fxAlign="center center">
  <div fxLayout="column" fxLayoutGap="20px">
 
    <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">
      <div fxLayoutAlign [fxLayout]="(media.isActive('lt-md')) ? 'column' : 'row'">
        <!-- Distribution Redemption Start Date -->
        <mat-form-field fxFlex>
          <input id="id_red_start_date" matInput [matDatepicker]="distribution_start_date" (click)="distribution_start_date.open()" formControlName="distribution_start_date" [placeholder]="'LABEL_REDEMPTION_START_DATE' | translate" [max]="formGroup.get('distribution_end_date').value" readonly>
 
          <mat-datepicker-toggle matSuffix [for]="distribution_start_date"></mat-datepicker-toggle>
          <mat-datepicker #distribution_start_date></mat-datepicker>
 
          <mat-error *ngIf="formGroup.get('distribution_start_date').hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error> 
        </mat-form-field>
 
        <div fxFlex></div>
 
        <!-- Distribution Redemption End Date -->
        <mat-form-field fxFlex>
          <input id="id_red_end_date" matInput [matDatepicker]="distribution_end_date" (click)="distribution_end_date.open()" formControlName="distribution_end_date" [placeholder]="'LABEL_REDEMPTION_END_DATE' | translate" [min]="formGroup.get('distribution_start_date').value" readonly>
          
          <mat-datepicker-toggle matSuffix [for]="distribution_end_date"></mat-datepicker-toggle>
          <mat-datepicker #distribution_end_date></mat-datepicker>
 
          <mat-error *ngIf="formGroup.get('distribution_end_date').hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error> 
        </mat-form-field>
      </div>
 
      <div>
        <!-- Status -->
        <mat-form-field class="form-field-filter">
          <mat-chip-list #chipsStatus aria-label="Status">
            <mat-chip [id]="'id_status_chip_' + (i+1)" *ngFor="let data of multiSelect.selectedStatus; let i = index" [removable]="true" (removed)="toggleSelection(data, statuses, 'selectedStatus'); statusInput.value = ''">
              {{data.status}}
              <mat-icon [id]="'id_status_chip_del_' + (i+1)" matChipRemove>
                cancel
              </mat-icon>
            </mat-chip>
            
            <input 
              matInput 
              #statusInput 
              formControlName="status" 
              [matAutocomplete]="statusAC" 
              [matChipInputFor]="chipsStatus" 
              (focus)="getInitialData('status')" 
              [matChipInputAddOnBlur]="true"
              [placeholder]="'LABEL_STATUS' | translate" 
              >
 
            <mat-icon 
              matSuffix
              color="primary"
              class="clear-input"
              svgIcon="close-circle"
              *ngIf="statusInput.value"
              [matTooltip]="'LABEL_CLEAR' | translate"
              (click)="statusInput.value = ''"
              >
            </mat-icon>
 
            <mat-icon matSuffix svgIcon="menu-down" *ngIf="!statusInput.value" class="autocomplete-arrow-color"></mat-icon>
          </mat-chip-list>
 
          <mat-autocomplete 
            id="id_status_dropdown"
            [displayWith]="displayFn"
            #statusAC="matAutocomplete"
            >
            <mat-option
              disabled
              *ngIf="!loading.status && filteredStatus?.length == 0"
              >
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>
 
            <ng-container *ngIf="!loading.status">
              <mat-option [id]="'id_status_data_' + (i+1)" *ngFor="let data of filteredStatus; let i = index" [value]="data" [disabled]="data.disabled">
                <div (click)="optionClicked($event, data, statuses, 'selectedStatus'); statusInput.value = ''" [class.disable]="data.disabled">
                  <mat-checkbox [id]="'id_status_checkbox_' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, statuses, 'selectedStatus'); statusInput.value = ''" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                    {{ data.status }}
                  </mat-checkbox>
                </div>
              </mat-option>
            </ng-container>
 
            <mat-option *ngIf="loading.status" disabled>
              <mat-spinner color="primary" class="margin-0au" mode="indeterminate" [diameter]="45"></mat-spinner>
            </mat-option>
 
            <mat-option *ngIf="!loading.status && (statuses?.length == 0)" disabled>
              No Data Found
            </mat-option>
          </mat-autocomplete>
 
          <mat-error *ngIf="formGroup.get('status').hasError('notExisting')">
            {{ 'MSG_DOESNT_EXIST' | translate: { type: 'LABEL_STATUS' | translate } }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
 
  </div>
</div>
 
<div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button id="id_apply_filter_btn" type="button" color="primary" mat-button (click)="assignFormValues('selectedStatus', 'status')"> {{ 'LABEL_APPLY' | translate }} </button>
  <button id="id_reset_filter_btn" type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  <button id="id_cancel_filter_btn" type="button" mat-button (click)="dialogRef.close()"> {{ 'LABEL_CANCEL' | translate }} </button>
</div>
 
<!-- buttons for mobile view -->
<div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button id="id_apply_filter_btn" type="button" color="primary" mat-icon-button (click)="assignFormValues('selectedStatus', 'status')">
    <mat-icon svgIcon="check"></mat-icon>
  </button>
 
  <button id="id_reset_filter_btn" type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>
 
  <button id="id_cancel_filter_btn" type="button" mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="cancel"></mat-icon>
  </button>
</div>